<app-page headerMode="none"
          headerLogoLink=""
          [showHeader]="false"
          [showFooter]="false"
          [footerShowNavi]="false">
  <div class="v2-max-w-120 margin-auto v2-min-h-50 body-2 color-green-grey-1 v2-padding-5-b"
       [ngClass]="sm ? 'v2-padding-2-h' : 'v2-padding-5-h'">
    <div class="h1 text-center v2-margin-6-b">Customer Relationship Summary</div>

    <h2>Introduction</h2>
    <p>Andes Capital Group, LLC (the “firm”) is registered with the Securities and Exchange Commission (SEC) as a
      broker-dealer and is a member of the Financial Industry Regulatory Authority (FINRA) and the Securities Investor
      Protection Corporation (SIPC). Brokerage and investment advisory services and fees differ, and it is important for
      you to understand these differences. Free and simple tools are available to research firms and financial
      professionals at Investor.gov/CRS, which also provides educational materials about broker-dealers, investment
      adviser, and investing.</p>

    <h3>Terms to know:</h3>
    <ul>
      <li>A broker-dealer is a firm that acts as an intermediary between buyers and sellers of securities for which they
        will usually receive a commission and may purchase or sell those securities in/out of their own account.</li>
      <li>An investment adviser is generally any person or group that provides investment advice or conducts securities
        analysis in exchange for a fee.</li>
    </ul>
    <p></p>

    <h2>What investment services and advice can you provide me?</h2>
    <p>We offer brokerage services to retail investors, including buying and selling securities and offering securities
      recommendations. We do not provide account monitoring services. We do not act with discretion in brokerage
      accounts. You make the ultimate decision regarding the purchase or sale of investments. We do not impose account
      value minimums, although our independent financial professionals may choose to do so.</p>

    <h2>Conversation Starters – Ask your financial professional:</h2>
    <ul>
      <li>Given my financial situation, should I choose a brokerage service? Why or why not?</li>
      <li>How will you choose investments to recommend to me?</li>
      <li>What is your relevant experience, including your licenses, education and other qualifications? What do these
        qualifications mean?</li>
    </ul>
    <p></p>

    <h4>What fees will I pay?</h4>
    <p>You will pay transaction-based fees for purchases or sales you decide to execute in your account, based on the
      product selection, brokerage service model, and account type. You will be charged more when there are more
      transactions in your account, therefore incentive exists for the firm or your financial professional to encourage
      you to trade more frequently. </p>
    <p> Some types of investments incur ongoing operational expenses which are directly or indirectly passed on to you.
    </p>
    <p> You will also pay fees for operational services provided through your account, such as custodial fees and account
      maintenance fees. These fees are charged at least annually and may be waived under certain conditions.</p>
    <p> You will pay fees and costs whether you make or lose money on your investments. Fees and costs will reduce any
      amount of money you make on your investments over time. Please make sure you understand what fees and costs you are
      paying.</p>


    <h2>Conversation Starter – Ask your financial professional:</h2>
    <ul>
      <li>Help me understand how these fees and costs might affect my investments. If I give you $10,000 to invest, how
        much
        will go to fees and costs, and how much will be invested for me?</li>

    </ul>
    <p></p>
    <h4> What are your legal obligations to me when providing recommendations? How else does your firm make money and
      what
      conflicts of interest do you have?</h4>
    <p>
      When we provide you with a recommendation, we have to act in your best interest and not put our interest ahead of
      yours. At the same time, the way we make money creates some conflicts with your interests. You should understand
      and
      ask us about these conflicts because they affect the recommendations we provide you. Here are some examples to help
      you understand what this means:</p>


    <ul>
      <li> Third-party payments may be based on sales of investment products thus incentivizing us to recommend you buy
        and sell
        investments.</li>
      <li> Revenue sharing, such as when we or our affiliate receives selling group compensation.</li>
      <li> Trail Compensation is ongoing compensation from product sponsors typically paid from the assets of an
        investment
        product based on an annual percentage of invested assets and varies by product. We therefore have an incentive to
        recommend products that pay higher “trails.”</li>
    </ul>
    <p></p>

    <h2>Conversation Starter – Ask your financial professional:</h2>
    <ul>
      <li>
        How might your conflicts of interest affect me, and how will you address them?</li>

    </ul>
    <p></p>
    <h4>
      How do your financial professionals make money?</h4>
    <p>
      The firm’s financial professionals are compensated based on a percentage of revenue generated from the sales of
      products and services to clients. This compensation varies by product, and financial professionals are therefore
      incentivized to recommend products that have higher fees and/or ongoing payments.</p>


    <p>
      Do your financial professionals have legal or disciplinary history?</p>
    <p>
      Yes. Visit Investor.gov/CRS for a free and simple search tool to research us and our financial professionals.</p>


    <h2>
      Conversation Starter – Ask your financial professional:</h2>
    <ul>
      <li>
        As a financial professional, do you have any disciplinary history? For what type of conduct?</li>

    </ul>
    <p></p>

    <h4>Where can I find additional information?</h4>
    <p>
      For additional information about our services, please visit our website at <a href="https://www.andescap.com"
         target="_blank">www.andescap.com</a> and/or offering
      materials
      provided by the firm. If you would like additional, up-to-date information or a copy of this disclosure, please
      call
      (312) 376-4500.</p>

    <h2>Conversation Starter – Ask your financial professional:</h2>
    <p>
      Who is my primary contact person? Is he or she a representative of an investment adviser or a broker-dealer? Who
      can
      I talk to if I have concerns about how this person is treating me?</p>
  </div>
</app-page>
